import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
export const GET_ASSOCIATION_DEFINITIONS = registerQuery({
  fieldName: 'flowDoctor_associationDefinitions',
  args: ['portalId'],
  fetcher({
    portalId
  }) {
    return HttpClient.get('associations/v1/definitions', {
      query: {
        portalId
      }
    });
  }
});